<!-- Header -->
<div class="d-flex flex-wrap flex-stack mb-6">
  <div>
    <h3 class="fw-bold my-2">{{ 'organisations.myOrganisations' | translate }}</h3>
    <p class="text-muted fs-6 mb-0">{{ 'organisations.subtitle' | translate }}</p>
  </div>
  <div class="d-flex flex-wrap my-2">
    <app-button
      [variant]="'primary'"
      [label]="'organisations.createOrganisation' | translate"
      [iconClass]="'fa fa-plus'"
      (clicked)="createNewOrganisation()"
    />
  </div>
</div>

<!-- Loading State -->
@if (loading) {
  <div class="text-center py-20 mb-9">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'organisations.loadingOrganisations' | translate }}</span>
    </div>
    <p class="text-muted mt-5">{{ 'organisations.loadingOrganisations' | translate }}</p>
  </div>
}

<!-- Empty State -->
@if (!loading && userCompanies.length === 0) {
  <div class="card mb-9">
    <div class="card-body text-center py-20">
      <i class="fa fa-building fs-3x text-muted mb-5"></i>
      <h3 class="text-muted">{{ 'organisations.noOrganisations' | translate }}</h3>
      <p class="text-muted">{{ 'organisations.noOrganisationsHint' | translate }}</p>
      <app-button
        [variant]="'primary'"
        [label]="'organisations.createFirstOrganisation' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="createNewOrganisation()"
      />
    </div>
  </div>
}

<!-- Organisations Grid -->
@if (!loading && userCompanies.length > 0) {
  <div class="row g-6 g-xl-9 mb-9">
    @for (userCompany of userCompanies; track userCompany.company.company_id) {
      <div class="col-md-6 col-lg-4">
        <div class="card h-100 organisation-card">
          <!-- Company Logo/Header -->
          <div class="card-header border-0 pt-9 pb-0" style="min-height: 150px; background-size: cover; background-position: center;" [style.background-image]="userCompany.company.header_image_url ? 'url(' + userCompany.company.header_image_url + ')' : 'none'" [style.background-color]="!userCompany.company.header_image_url ? '#f5f5f5' : 'transparent'">
            <div class="card-toolbar">
              <span class="badge" [ngClass]="getRoleBadgeClass(userCompany.role_id)">
                {{ userCompany.role_name }}
              </span>
            </div>
          </div>

          <div class="card-body p-9">
            <!-- Company Logo -->
            <div class="d-flex flex-center mb-5">
              <div class="symbol symbol-75px symbol-circle">
                @if (userCompany.company.company_logo_url) {
                  <img [src]="userCompany.company.company_logo_url" [alt]="userCompany.company.company_name" class="organisation-logo"/>
                } @else {
                  <div class="symbol-label bg-light">
                    <i class="fa fa-building fs-2x text-muted"></i>
                  </div>
                }
              </div>
            </div>

            <!-- Company Name -->
            <div class="text-center mb-5">
              <h3 class="fw-bold mb-1">{{ userCompany.company.company_name }}</h3>
              @if (userCompany.company.company_type) {
                <div class="mb-2">
                  <span class="badge badge-light-info">
                    <i class="fa {{ getOrganisationTypeIcon(userCompany.company.company_type) }} me-1"></i>
                    {{ getOrganisationTypeLabel(userCompany.company.company_type) }}
                  </span>
                </div>
                @if (userCompany.company.company_type === 'stores_services' && userCompany.company.category) {
                  <div class="mb-2">
                    <span class="badge badge-light-primary">
                      @if (userCompany.company.category.icon) {
                        <i class="fa {{ userCompany.company.category.icon }} me-1"></i>
                      }
                      {{ userCompany.company.category.name || userCompany.company.category.name_en }}
                    </span>
                  </div>
                }
              }
              @if (userCompany.company.organisation_number) {
                <div class="text-muted fs-7">{{ 'organisations.org' | translate }} {{ userCompany.company.organisation_number }}</div>
              }
            </div>

            <!-- Company Details -->
            <div class="mb-7">
              @if (userCompany.company.city || userCompany.company.country) {
                <div class="d-flex align-items-start mb-3">
                  <i class="fa fa-location-dot text-primary me-2 fs-6 mt-1"></i>
                  <div class="flex-grow-1">
                    <span class="text-gray-800 fs-7">
                      {{ userCompany.company.city }}@if (userCompany.company.city && userCompany.company.country) {, }{{ userCompany.company.country }}
                    </span>
                  </div>
                </div>
              }

              @if (userCompany.company.email) {
                <div class="d-flex align-items-start mb-3">
                  <i class="fa fa-envelope text-primary me-2 fs-6 mt-1"></i>
                  <div class="flex-grow-1">
                    <a [href]="'mailto:' + userCompany.company.email" class="text-gray-800 text-decoration-none fs-7">
                      {{ userCompany.company.email }}
                    </a>
                  </div>
                </div>
              }

              @if (userCompany.company.phone) {
                <div class="d-flex align-items-start">
                  <i class="fa fa-phone text-primary me-2 fs-6 mt-1"></i>
                  <div class="flex-grow-1">
                    <a [href]="'tel:' + userCompany.company.phone" class="text-gray-800 text-decoration-none fs-7">
                      {{ userCompany.company.phone }}
                    </a>
                  </div>
                </div>
              }
            </div>

            <!-- Action Button -->
            <div class="mt-auto">
              <app-button
                [variant]="'primary'"
                [label]="'organisations.view' | translate"
                [iconClass]="'fa fa-eye'"
                [width]="'100%'"
                (clicked)="viewOrganisation(userCompany)"
              />
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
